import {createContext} from 'react';

const noop = () => {};
const nooop = () => () => {};

import type {InternalContextDescriptor, PublicContextDescriptor} from './types';

export const defaultPublicContext: PublicContextDescriptor = {
	handleItemClick: nooop,
	handleItemInteractStart: nooop,
	handleScrollIndexUpdate: noop,
	setActiveIndex: noop,
	justClickedItem: {current: false},
	disableNextScrollUpdate: {current: false},
	disabled: true,
	activeIndex: 0,
	virtualListRef: undefined,
};

export const defaultInternalContext: InternalContextDescriptor = {
	keysDisabled: false,
	clickKeysDisabled: false,
	disableNextScrollUpdate: {current: false},
	disabled: true,
	activeIndex: 0,
	returnToIndexOnFocus: -1,
	justClickedItem: {current: false},
	sendNextFocusToPreviousElement: {current: false},
	virtualListRef: undefined,
	dispatch: noop,
	handleItemClick: nooop,
	handleItemInteractStart: nooop,
	handleScrollIndexUpdate: noop,
	setActiveIndex: noop,
	setReturnToIndexOnFocus: noop,
};

export const InternalContext = createContext<InternalContextDescriptor>(
	defaultInternalContext,
);

export const PublicContext =
	createContext<PublicContextDescriptor>(defaultPublicContext);
